/**
 * Deep M: three firefly nests, each under a boulder held up by a door. Taking a key drops the
 * boulder and the blast breaks open the hearth beside the nest; each hearth holds the next key
 * (docs/spec/03 §3).
 */

import type { CaveDef } from '../types';

export const deepM: CaveDef = {
  id: 'M',
  name: 'HEARTH',
  hint: 'A key drops a stone on a nest. Stand well back.',
  intermission: false,
  colors: [2, 12, 7],
  diamondValue: 26,
  extraValue: 48,
  fill: { base: '.', items: [['r', 12], ['d', 4]] },
  levels: [
    { seed: 6301, diamonds: 20, time: 150 },
    { seed: 6302, diamonds: 25, time: 140 },
    { seed: 6303, diamonds: 30, time: 130 },
    { seed: 6304, diamonds: 35, time: 120 },
    { seed: 6305, diamonds: 40, time: 110 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W??????????????????????????????????????W',
    'W????www????????????????????????www????W',
    'W????wrw????????????????????????wrw????W',
    'W????w4WWWWW????????????????WWWWW5w????W',
    'W????w wdddW????????????????Wdddw w????W',
    'W????wfwd2dr????????????????rd3dwfw????W',
    'W????wwwdddW????????????????Wdddwww????W',
    'W??????WWWWW????????????????WWWWW??????W',
    'W??????????????????????????????????????W',
    'W.P.???????????????????????????????????W',
    'W...???????????????????????????????????W',
    'W??????????????????www?????????????????W',
    'W?????????????????..rw?????????????????W',
    'W??????????????WWWWw6wWWWWWW???????????W',
    'W??????????????Wdddw wdddddW???????????W',
    'W??????????????rdddwfwdddddr???????????W',
    'W??????????????WdddwwwdddddW???????????W',
    'W??????????????WWWWWWWWWWWWW???????????W',
    'W.1.??????????????????????????????.....W',
    'W?????????????????????????????????...X.W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
